import { observer } from 'mobx-react';
import * as React from 'react';
import { transl } from '../main/transl';
import { mg } from '../mg/mg';
import { commSvc, IOcResponse } from '../services/CommSvc';

export interface IPublicEnumInfoElement {
	id: string
	members: Array<string>
	translations: Array<string>
}

const key = 'publicEnumInfo';

export const publicEnumInfoMap: Map<string, IPublicEnumInfoElement> = new Map();

@observer export class PublicEnumInfoLifecycle extends React.Component {
	_write(list: Array<IPublicEnumInfoElement> | undefined) {
		if (!list) return;
		publicEnumInfoMap.clear();
		list.forEach((i: IPublicEnumInfoElement) => publicEnumInfoMap.set(i.id, i));
	}

	componentDidMount() {
		this._write(mg.storage.get(key));
		commSvc.doGet('PublicEnumInfo', {language: 'de'})
			.then(commSvc.requireOutputList)
			.then((r: IOcResponse) => {
				if (!r.outputList) return;
				this._write(r.outputList as any);
				const list = [...publicEnumInfoMap.values()];
				transl.applyPublicEnumInfo(list);
				mg.storage.put(key, list);
			});
	}

	render() {
		return null;
	}
}
